












import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Plain extends Vue {
  private handleResizeTimerId: number = -1;

  public async mounted(): Promise<void> {
    window.addEventListener('resize', this.handleResizeScheduler);
    this.handleResize();
  }

  beforeDestroy(): void {
    window.clearTimeout(this.handleResizeTimerId);
    window.removeEventListener('resize', this.handleResizeScheduler);
  }

  private handleResizeScheduler(): void {
    window.clearTimeout(this.handleResizeTimerId);
    this.handleResizeTimerId = window.setTimeout((): void => {
      this.handleResize();
    }, 1000);
  }

  private handleResize(): void {
    // 画面サイズ記録
    if (this.$store.getters['camera/isPC']) {
      // innerWidthだとスクロールバーの幅も含まれる様なのでclientWidthを使用
      this.$store.commit('camera/displayWidth', document.documentElement.clientWidth);
      this.$store.commit('camera/displayHeight', document.documentElement.clientHeight);
    } else {
      // 手元の端末だとinnerWidthは存在する要素の横幅につられて実際よりも大きな横幅になってしまうことがある
      // 横向きから縦向きに戻した際にinnerWidthだとおかしくなり、その場合はclientWidthを使う方が良さそうである
      // ただしclientWidthはアドレスバーの非表示を検知できず、アドレスバーが隠れると下に隙間ができる
      // そのため、横幅の絶対値はclientWidthが正しく、縦幅の比はinnerHeightが正しいものとして計算する
      const ratio: number = document.documentElement.clientWidth / window.innerWidth;
      this.$store.commit('camera/displayWidth', window.innerWidth * ratio);
      this.$store.commit('camera/displayHeight', window.innerHeight * ratio);
    }
  }
}
